/** Naegele's rule: the due date is 280 days after the first day of the last menstrual period. */
const GESTATION_DAYS = 280;

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * The estimated due date for a last menstrual period, as a plain `yyyy-MM-dd` calendar date.
 *
 * Counted in UTC on purpose. The arithmetic used to add 280 days to **local** midnight and read the
 * result back in UTC, so a due date landing in Irish summer time came out a day early — an LMP of
 * 2026-09-03 stored 2027-06-09 for a date that is 10 June locally (KIN-2064). A due date is a
 * calendar fact with no time in it, and the receiving hospital derives the gestation from it for
 * every later message (MN-CMS v0.18 §4), so it must not depend on where or when it was entered.
 *
 * One home for this, used by the forms and by both mutations: the display and the posted value
 * drifting apart is what KIN-2061 was.
 */
export const calcEstimatedDueDate = (lastMenstrualPeriod) => {
  const parts = ISO_DATE.exec(lastMenstrualPeriod ?? "");

  if (!parts) return null;

  const [, year, month, day] = parts;
  const dueDate = new Date(
    Date.UTC(Number(year), Number(month) - 1, Number(day) + GESTATION_DAYS)
  );

  if (Number.isNaN(dueDate.getTime())) return null;

  return dueDate.toISOString().split("T")[0];
};
